import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const CrossIcon = _ref => {
  let {
      size = "13",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 22 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    d: "M4.30679 1.09781C4.52949 0.875111 4.83154 0.75 5.14648 0.75H8.52148C8.83643 0.75 9.13847 0.875111 9.36117 1.09781C9.58387 1.32051 9.70898 1.62255 9.70898 1.9375V4.125H11.8965C12.2114 4.125 12.5135 4.25011 12.7362 4.47281C12.9589 4.69551 13.084 4.99756 13.084 5.3125V8.6875C13.084 9.00244 12.9589 9.30449 12.7362 9.52719C12.5135 9.74989 12.2114 9.875 11.8965 9.875H9.70898V12.0625C9.70898 12.3774 9.58387 12.6795 9.36117 12.9022C9.13847 13.1249 8.83643 13.25 8.52148 13.25H5.14648C4.83154 13.25 4.5295 13.1249 4.30679 12.9022C4.0841 12.6795 3.95898 12.3774 3.95898 12.0625V9.875H1.77148C1.45654 9.875 1.15449 9.74989 0.931795 9.52719C0.709096 9.30449 0.583984 9.00244 0.583984 8.6875V5.3125C0.583984 4.99755 0.709096 4.69551 0.931795 4.47281C1.15449 4.25011 1.45654 4.125 1.77148 4.125H3.95898V1.9375C3.95898 1.62255 4.0841 1.32051 4.30679 1.09781ZM5.20898 2V4.75C5.20898 5.09518 4.92916 5.375 4.58398 5.375H1.83398V8.625H4.58398C4.92916 8.625 5.20898 8.90482 5.20898 9.25V12H8.45898V9.25C8.45898 8.90482 8.73881 8.625 9.08398 8.625H11.834V5.375H9.08398C8.73881 5.375 8.45898 5.09518 8.45898 4.75V2H5.20898Z",
    fill: color
  }));
};
export default CrossIcon;